module.exports = __webpack_public_path__ + "assets/img/events-point-07.8f6f5bfa.png";